import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './style.scss';

const References = (props) => {
  const [page, setPage] = useState(0);
  const [mobile, setMobile] = useState(false);
  const [numPages, setNumPages] = useState(0);
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const referencesRef = React.createRef();

  function updateDimensions() {
    setMobile(window.innerWidth < 1024);
    setNumPages(window.innerWidth < 1024 ? references.length : Math.ceil(references.length / 5));
  }

  function scrollToPage(p) {
    if(p < 0) {
      p = 0;
    } else if(p >= numPages) {
      p = numPages - 1;
    }

    setPage(p);
    if (referencesRef.current) {
      referencesRef.current.scrollTo({
        left: referencesRef.current.clientWidth * p,
        behavior: 'smooth'
      });
    }
  }

  useEffect(() => {
    // Fetch references from the API
    setLoading(true);
    
    // Get the current URL path
    const url = window.location.pathname;
    
    fetch(`https://nsbackend.campaigns.fi/references/public?url=${encodeURIComponent(url)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setReferences(data);
        setLoading(false);
        setError(null);
      })
      .catch(error => {
        console.error('Error loading references:', error);
        setError('Failed to load references');
        setLoading(false);
      });
  }, [props.location]);

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [references.length]);

  if (loading) {
    return <div className="loading">Loading references...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  let referenceElements;

  if(mobile) {
    referenceElements = references.map((reference, index) => {
      return <div className="page" key={index}>
        <a className="reference" href={reference.link} style={{backgroundImage: `url(${reference.image})`}}>{reference.name}</a>
      </div>
    });
  } else {
    // Split references into chunks of 5 per page for desktop
    let referencePages = [];
    let chunk = [];

    references.forEach((reference, index) => {
      chunk.push(reference);

      if(chunk.length === 5) {
        referencePages.push(chunk);
        chunk = [];
      }
    });

    if (chunk.length > 0) {
      referencePages.push(chunk);
    }
      
    referenceElements = referencePages.map((page, pageIndex) => {
      return <div className="page" key={pageIndex}>
        {page.map((reference, index) => {
          return <a className="reference" key={index} href={reference.link} style={{backgroundImage: `url(${reference.image})`}}>{reference.name}</a>
        })}
      </div>
    });
  }

  return (
    <Container className="text-center">
      <Row>
        <Col>
          <div className="reference-carousel">
            <div className={"arrow left" + (page === 0 ? ' disabled' : '')} onClick={() => {scrollToPage(page - 1)}}>&#10094;</div>
            <div className={"arrow right" + (page === numPages - 1 ? ' disabled' : '')} onClick={() => {scrollToPage(page + 1)}}>&#10095;</div>

            <div className="references" ref={referencesRef}>
              {referenceElements}
            </div>

            <div className="reference-carousel-dots">
              {(numPages > 0) && Array.from(Array(numPages).keys()).map((p, index) => {
                return <span className={"dot" + (page === p ? ' active' : '')} key={index} onClick={() => {scrollToPage(p)}}></span>
              })}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default References;
